import { CONTACT } from "@/constants/contact";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-xl font-semibold uppercase">{title}</h2>
    <div className="mt-3 space-y-3 text-sm text-muted-foreground">{children}</div>
  </section>
);

export default function PolitiqueConfidentialitePage() {
  return (
    <div data-testid="privacy-page" className="mx-auto max-w-3xl px-4 py-20">
      <h1 className="font-display text-4xl font-bold uppercase sm:text-5xl">
        Politique de confidentialité
      </h1>
      <p className="mt-4 text-sm text-muted-foreground">
        Dernière mise à jour : octobre 2026
      </p>

      <Section title="Responsable du traitement">
        <p>
          {CONTACT.name} — {CONTACT.address} — SIRET {CONTACT.siret} — Tél.{" "}
          {CONTACT.phoneDisplay} — {CONTACT.email}.
        </p>
      </Section>

      <Section title="Données collectées">
        <p>
          Via nos formulaires de demande de devis et de dépôt-vente : nom,
          adresse e-mail, numéro de téléphone, véhicule (marque, modèle, année,
          kilométrage) et le contenu de votre message.
        </p>
        <p>
          Dans le cadre d'une demande de véhicule de prêt ou de location : les
          documents que vous joignez (permis de conduire, carte d'identité,
          justificatif de domicile) sont utilisés uniquement pour constituer
          votre dossier et sont transmis au garage.
        </p>
      </Section>

      <Section title="Finalités et base légale">
        <p>
          Vos données sont utilisées uniquement pour répondre à votre demande
          (devis, rendez-vous, dépôt-vente) et vous recontacter. Le traitement
          repose sur votre consentement, recueilli par la case à cocher
          présente dans chaque formulaire.
        </p>
      </Section>

      <Section title="Destinataires et durée de conservation">
        <p>
          Les demandes sont transmises au garage (messagerie WhatsApp et
          e-mail professionnel) et ne sont pas cédées à des tiers. Elles sont
          conservées au maximum 3 ans à compter de votre dernier contact.
        </p>
      </Section>

      <Section title="Vos droits">
        <p>
          Conformément au RGPD, vous disposez d'un droit d'accès, de
          rectification, d'effacement, de limitation et d'opposition sur vos
          données. Pour les exercer, écrivez à {CONTACT.email} ou appelez le{" "}
          {CONTACT.phoneDisplay}. Vous pouvez également saisir la CNIL
          (www.cnil.fr).
        </p>
      </Section>

      <Section title="Cookies">
        <p>
          Ce site ne dépose aucun cookie publicitaire. Seul votre choix de
          consentement est conservé sur votre appareil, et une mesure
          d'audience peut être appliquée si vous l'acceptez via le bandeau
          cookies. Vous pouvez modifier votre choix à tout moment via le lien
          « Gérer les cookies » en bas de page.
        </p>
      </Section>

      <Section title="Sécurité">
        <p>
          Nous mettons en œuvre les mesures techniques et organisationnelles
          appropriées pour protéger vos données contre tout accès non
          autorisé, perte ou divulgation.
        </p>
      </Section>
    </div>
  );
}
